import React, { ReactNode, useCallback, useMemo, useRef } from 'react';
import { Toast } from 'primereact/toast';

import ToastNotification from '../../components/ToastNotification/ToastNotification';
import { ToastNotificationContext } from './ToastNotification';

type ISeverity = 'success' | 'info' | 'warn' | 'error';

export const ToastNotificationProvider: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  const toastBR = useRef<Toast>(null);

  const showToast = useCallback(
    ({
      severity,
      detail,
    }: {
      severity: ISeverity;
      detail: string | ReactNode;
    }) => {
      if (toastBR.current) {
        toastBR.current.show({
          severity,
          detail,
          life: 10000,
        });
      }
    },
    []
  );

  const contextValue = useMemo(() => {
    return { showToast };
  }, [showToast]);

  return (
    <ToastNotificationContext.Provider value={contextValue}>
      {children}
      <ToastNotification toastRef={toastBR} />
    </ToastNotificationContext.Provider>
  );
};
